export default __webpack_public_path__ + "static/media/vetor institucionais.53661c21.svg";